import { useEffect } from 'react';

const SITE = 'CassioDev';

export const useDocumentTitle = (title: string, description?: string) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${SITE}` : SITE;

    let metaDesc: HTMLMetaElement | null = null;
    let previousDesc: string | null = null;

    if (description) {
      metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        previousDesc = metaDesc.getAttribute('content');
        metaDesc.setAttribute('content', description);
      }
    }

    return () => {
      document.title = previous;
      if (metaDesc && previousDesc !== null) {
        metaDesc.setAttribute('content', previousDesc);
      }
    };
  }, [title, description]);
};

export default useDocumentTitle;
